import React from 'react';
import './Projects.css'; // Import the CSS file for styling

function Projects() {
    return (
        <>
            <h2 className="projects-title">Projects</h2>
            <ul className="projects-list">
                <li className="project-item">
                    <h3 className="project-title">Integrating External Services with Consul Service Mesh</h3>
                    <p className="project-description">
                        This project focuses on the integration of external services that contain paths in their endpoints into the
                        Consul Service Mesh. It offers a comprehensive guide on setting up and configuring Consul agents, defining
                        service registrations, and managing path-based routing. By following this guide, you will learn how to ensure
                        seamless service discovery and health checks, which are crucial for maintaining a robust and reliable service
                        architecture. The project also delves into best practices for monitoring and troubleshooting within the Consul
                        ecosystem. For more details, you can read the full publication.
                    </p>
                    <a href="https://medium.com/stepstone-tech/register-external-services-containing-paths-in-endpoints-into-consul-service-mesh-d6c7b67e4eb3" target="_blank" rel="noopener noreferrer" className="project-button">Read More</a>
                </li>
                <li className="project-item">
                    <h3 className="project-title">DevOps Management and AWS Infrastructure at Geeks Academy</h3>
                    <p className="project-description">
                        This project involved managing the entire DevOps pipeline and AWS infrastructure for the open-source projects at
                        Geeks Academy. Responsibilities included setting up and maintaining CI/CD pipelines, ensuring smooth deployment
                        processes, and managing the AWS infrastructure to support various applications. Additionally, I led the DevOps
                        team, managed the backlog and Kanban board, and provided training on DevOps topics to team members. This role
                        required a deep understanding of cloud services, automation tools, and best practices in DevOps.
                    </p>
                    <a href="https://github.com/Geeks-Academy" target="_blank" rel="noopener noreferrer" className="project-button">Read More</a>
                </li>
                <li className="project-item">
                    <h3 className="project-title">Custom Domain for Pay-As-You-Go Azure App Service</h3>
                    <p className="project-description">
                        This project provides a step-by-step guide on how to set up a custom domain for a Pay-As-You-Go Azure App Service.
                        It covers the process of purchasing a domain, configuring DNS settings, and linking the domain to the Azure App
                        Service. The guide ensures that users can easily follow along to achieve a professional and branded web presence
                        using Azure services.
                    </p>
                    <a href="https://dev.to/bwieckow/custom-domain-for-pay-as-you-go-azure-app-service-chn" target="_blank" rel="noopener noreferrer" className="project-button">Read More</a>
                </li>
                <li className="project-item">
                    <h3 className="project-title">Centralised Secret Management</h3>
                    <p className="project-description">
                        This project aimed to ensure safe and cost-effective secret management compared to AWS Secret Manager,
                        particularly for API keys and their rotations to be zero downtime for both API key owners and consumers.
                        Using Terraform, I built a module that stores secrets in Hashicorp Vault, AWS Step Function, and AWS Event Rules
                        for handling secret rotation and ECS services zero downtime. The envconsul binary was used to retrieve vault
                        secrets and feed applications with them during container startup.
                    </p>
                </li>
            </ul>
        </>
    );
}

export default Projects;
